<template>
  <div>
    <van-field
      v-bind="$attrs"
      :value="showValue"
      is-link
      clickable
      readonly
      placeholder="请选择地区"
      :rules="rules"
      @click="popupShow = true"
    />
    <van-popup
      v-model="popupShow"
      v-bind="$attrs"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="popupShow = false"
      />
    </van-popup>
  </div>
</template>

<script >
import { getDealerAreaData } from '@/api/public';
import { getCurrentAddress } from '@/utils/map';

export default {
  name: 'NxSelectDealerArea',
  props: {
    value: {
      type: Array,
      required: true,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    // 总共显示几列，1-3
    cols: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      popupShow: false,
      columns: [],
    };
  },
  computed: {
    value_: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
        this.$emit('change', newVal);
      },
    },
    showValue() {
      return this.value_?.join?.('') || '';
    },
  },
  async created() {
    try {
      const { addressComponent } = await getCurrentAddress();
      const { province, city } = addressComponent;
      this.value_ = [province, city];
    }
    catch (e) {
      console.error(e);
    }
    const { data } = await getDealerAreaData();
    this.$set(this, 'columns', this.parseColumns(data, 1));
  },
  methods: {
    onConfirm(val) {
      this.popupShow = false;
      this.value_ = val;
    },
    parseColumns(rawData, currentCol) {
      return Object.entries(rawData).map(([key, value]) => {
        const temp = { text: key };
        if (currentCol === this.cols) {
          return temp;
        }
        if (!Array.isArray(value)) {
          temp.children = this.parseColumns(value, currentCol + 1);
        }
        else {
          temp.children = value.map(v => ({ text: v }));
        }
        return temp;
      });
    },
  },
};
</script>

<style scoped lang="scss">

</style>
